import React from 'react';
import Typography from '@material-ui/core/Typography';
import {Link} from 'react-router-dom';
import './style.css';
import { borderRadius } from '@material-ui/system';
import { sendData } from '../../../../analytics/sendData';
import { FormattedMessage } from 'react-intl';



class DailyLove extends React.Component {

    redirect = () => {
        let min = Math.ceil(0);
        let max = Math.floor(11);
        let cardNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        let url = 'tarot' + cardNumber;
        this.props.history.push(url);
    }

    componentDidMount() {
        sendData('', 'love tarot' , 'viewed');
    }

    render() {
    let countryCode = JSON.parse(sessionStorage.getItem('countryCode'));
    return (
        <div className={'cmp'} style={countryCode.countryCode === 'no' ? { height: '120vh'} : { height: '100vh'}}>     
                <div style={{ textAlign: 'center', fontWeight: '300', letterSpacing: '0.05em', textTransform: 'capitalize',
                                            color: '#e0515d', marginTop: '70px', marginBottom: '20px',
                                            fontSize: '40px', fontFamily: 'balthazar,serif'}}>
                    <FormattedMessage id="dailylove.title"
                                defaultMessage="Free Daily Love Tarot Reading"
                                />
                </div>
                <div component="p" style={{color: '#fefefe',
                                            fontFamily: 'balthazar,serif',
                                            fontSize: '1.8rem',
                                            fontWeight: '400', width: '100%',minWidth:'320px',
                                            maxWidth:'640px', left: '50%', transform: 'translateX(-50%)',
                                            textAlign: 'center', position: 'relative' 
                                            }}>
                        
                        <FormattedMessage id="dailylove.desc"
                                defaultMessage="Know what's in store for you romantically each day with your Love Tarot reading. Hot date? Drama? Lonely night? Find out what to expect now"
                                />
                </div>
                <h1 style={{display: 'flex', justifyContent: 'center', textAlign: 'center', 
                                    marginBottom: '60px', fontSize: '2.5rem',
                                    fontWeight: '300', letterSpacing: '.05em',
                                    textTransform: 'uppercase', fontFamily: 'balthazar,serif', 
                                    marginTop: '20px', color: '#e0515d'}}>
                    <FormattedMessage id="pickOneCard"
                                defaultMessage="PICK ONE CARD"
                                />
                </h1>
                
            <div style={{backgroundColor: 'transparent', display: 'table',
                        width: '100%', tableLayout: 'fixed'}}>
                <div style={{width: '33%',display: 'table-cell', color: '#fefefe',
                              fontFamily: 'balthazar,serif',
                              fontWeight: '400', position: 'relative'
                            }}>
                    
                    <div className="def">
                        <div className="xyz">
                            <div
                                className="abc1"
                                style={{
                                    
                                    top: '50px',
                                    left: '-390px',
                                    zIndex: '11',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc2"
                                style={{
                                    
                                    top: '35px',
                                    left: '-325px',
                                    zIndex: '10',
                                    
                                }}
                                onClick={() => {this.redirect()}}

                            />
                            <div
                                className="abc3"
                                style={{
                                    
                                    top: '20px',
                                    left: '-260px',
                                    zIndex: '9',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc4"
                                style={{
                                    
                                    top: '10px',
                                    left: '-195px',
                                    zIndex: '8',
                                    

                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc5"
                                style={{
                                    
                                    top: '4px',
                                    left: '-130px',
                                    zIndex: '7',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc6"
                                style={{
                                    
                                    top: '0px',
                                    left: '-65px',
                                    zIndex: '6',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc7"
                                style={{
                                    
                                    top: '4px',
                                    left: '0px',
                                    zIndex: '5',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc8"
                                style={{
                                    
                                    top: '10px',
                                    left: '65px',
                                    zIndex: '4',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc9"
                                style={{
                                    
                                    top: '20px',
                                    left: '130px',
                                    zIndex: '3',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc10"
                                style={{
                                    
                                    top: '35px',
                                    left: '195px',
                                    zIndex: '2',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                            <div
                                className="abc11"
                                style={{
                                    
                                    top: '50px',
                                    left: '260px',
                                    zIndex: '1',
                                    
                                }}
                                onClick={() => {this.redirect()}}
                            />
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
        )}
    }

export default DailyLove;



// WEBPACK FOOTER //
// ./src/mobioastro/components/screens/tarotreading/dailyLove.js